<template>
  <v-container
    grid-list-xl
    fluid
    class="pt-0"
    v-if="totalBilling && totalBilling.id && totalBilling.summarize"
  >
    <v-card class="pr-2 pl-2">
      <v-card-title primary-title>
        <div>
          <div class="title">Gestão Financeira</div>
        </div>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="totalBilling.summarize.financialManagement"
        class="elevation-0 px-2 py-2"
        hide-actions
        :expand="expand"
        item-key="text"
      >
        <template v-slot:headers="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="header.class ? header.class : 'text-xs-right'"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <!-- <tr v-if="props.item.subitems" @click="props.expanded = !props.expanded"> -->
          <tr @click="showSubItems(props)">
            <!-- <tr v-else> -->
            <!-- <tr v-if="!Array.isArray(props.item.value)"> -->
            <td>
              {{ props.item.text }}
              <v-icon v-if="props.item.subitems">expand_more</v-icon>
            </td>
            <td class="text-xs-right">
              R$ {{ props.item.value | formatCurrency }}
            </td>
            <td class="text-xs-right">
              {{ props.item.percentage | formatCurrency }}%
            </td>
            <td
              v-for="partner in partners"
              :key="partner.partner"
              :class="partner.class"
            >
              {{
                (Number(props.item.value) * (partner.percentage / 100))
                  | formatCurrency
              }}
            </td>
            <!-- <td class="text-xs-right teal lighten-2 dark teal--text text--darken-4  hidden-sm-and-down">R$ {{ (props.item.value * 0.1)  | formatCurrency}}</td>
                        <td class="text-xs-right blue dark lighten-2 blue--text text--darken-4  hidden-sm-and-down">R$ {{ (props.item.value * 0.9)  | formatCurrency}}</td> -->
          </tr>
        </template>
        <template v-slot:expand="props">
          <v-data-table
            :headers="subheaders"
            :items="props.item.subitems"
            hide-actions
          >
            <template v-slot:subheaders="props">
              <tr>
                <th
                  v-for="header in props.subheaders"
                  :key="header.text"
                  :class="header.class ? header.class : 'text-xs-right'"
                >
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <template v-slot:items="subitems">
              <td>{{ subitems.item.status | formatTransactionStatus }}</td>
              <!-- <td>{{ subitems.item.status}}</td> -->
              <td class="text-xs-right">
                R$ {{ subitems.item.total.sum | formatCurrency }}
              </td>
              <td class="text-xs-right">
                R$ {{ subitems.item.total.taxa | formatCurrency }}
              </td>
              <td class="text-xs-right">
                R$
                {{
                  (Number(subitems.item.total.sum) -
                    Number(subitems.item.total.taxa))
                    | formatCurrency
                }}
              </td>
              <td class="text-xs-right">
                {{ subitems.item.total.count | formatInt }}
              </td>
            </template>
          </v-data-table>
          <!-- <v-card flat>
                        <v-card-text>{{props.item.subitem.text}}</v-card-text>
                    </v-card> -->
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("billing", ["totalBilling", "filters"]),
  },
  watch: {
    filters() {
      this.power_plant = this.filters.power_plant;

      if (
        this.power_plant &&
        this.power_plant.has_split &&
        Array.isArray(this.power_plant.split)
      ) {
        this.partners = [];
        this.headers = [
          {
            text: "",
            sortable: false,
          },
          { text: "Valor" },
          { text: "Percentual" },
        ];
        this.power_plant.split.map((split, i) => {
          let header = {
            text: split.partner + " (" + split.percentage + "%)",
            class:
              "text-xs-right " +
              this.colors[i] +
              " darken-2 dark white--text with-border font-weight-black hidden-sm-and-down",
          };
          this.headers.push(header);
          this.partners.push({
            partner: split.partner,
            name: split.name,
            percentage: split.percentage,
            class:
              "text-xs-right " +
              this.colors[i] +
              " lighten-2 dark white--text with-border font-weight-black hidden-sm-and-down",
          });
        });
      }
    },
  },
  data: () => ({
    colors: ["teal", "blue", "cyan", "orange"],
    partners: [],
    expand: false,
    headers: [
      {
        text: "",
        sortable: false,
      },
      { text: "Valor" },
      { text: "Percentual" },
      //   { text: 'Enercred (10%)', class: 'text-xs-right teal darken-2 dark white--text with-border font-weight-black hidden-sm-and-down'},
      //   { text: 'Parceiro (90%)', class: 'text-xs-right blue darken-2 dark white--text with-border font-weight-black hidden-sm-and-down'},
    ],
    subheaders: [
      {
        text: "Status",
        sortable: false,
        class: "font-weight-bold",
      },
      { text: "Valor", sortable: false, class: "text-xs-right" },
      { text: "Taxas Financ.", sortable: false, class: "text-xs-right" },
      { text: "A receber", sortable: false, class: "text-xs-right" },
      {
        text: "Quantidade de Membros",
        sortable: false,
        class: "text-xs-right",
      },
    ],
  }),
  methods: {
    showSubItems(props) {
      if (props.item.subitems) return (props.expanded = !props.expanded);
      else return props.expanded;
    },
  },
};
</script>
